import http from "./httpService";
import axios from "axios";

import config from "./config.json";
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export const postData = (address, data) => {
    const url = `${config.apiAddress}/${address}`;

     const formBody = Object.keys(data)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key] ?? '')}`)
    .join('&');

    console.log("StoreLog:", url, formBody);
    return http.post(url, formBody);
};

export const getData = (address,data) => {   
    var queryString = Object.keys(data).map(key => key + '=' + data[key]).join('&');
    var request=`${config.apiAddress}/${address}?${queryString}`;
    console.log("StoreLog: "+request);
    return http.get(request);
};

